export interface SkeletonProps {
  className?: string;
  label?: string;
}

export function Skeleton({
  className = "h-4 w-full",
  label = "Loading",
}: SkeletonProps) {
  return (
    <div role="status" aria-label={label} className="motion-reduce:animate-none">
      <div
        aria-hidden="true"
        className={`relative overflow-hidden rounded bg-line/75 before:absolute before:inset-y-0 before:w-1/2 before:bg-gradient-to-r before:from-transparent before:via-surface/80 before:to-transparent before:motion-safe:animate-[skeleton-sheen_1.8s_ease-in-out_infinite] ${className}`}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
